import htmlComponent from 'htmlcomponent'
import {storeScrollPos, restoreScrollPos} from '@/utils/scrollpos';

export default function(dom, opts) {
	let options = {
		type: 'overlay',
		listeners: true,
		...opts
	};
	const html = document.documentElement;
	const showClass = `show--${options.type}`;

	if (options.listeners) {
		htmlComponent.listen('overlay:open', (e, data) => {
			if (data.type !== options.type) {
				html.classList.remove(showClass);
			}
			else {
				storeScrollPos();
				html.classList.add(showClass);
			}
		});

		htmlComponent.listen('overlay:close', (e, data) => {
			if (data.type === options.type) {
				html.classList.remove(showClass);
				restoreScrollPos();
			}
		});

		htmlComponent.listen('overlay:toggle', (e, data) => {
			if (data.type === options.type) {
				if (html.classList.contains(showClass)) {
					htmlComponent.send('overlay:close', options);
				}
				else {
					htmlComponent.send('overlay:open', options);
				}
			}
		});
	}

	dom.addEventListener('click', e => {
		e.preventDefault();

		htmlComponent.send('overlay:toggle', options);
	});
}
